import { ErrorMessage, Field, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { CommonPageHeading } from '../../../CommonUtils/CommonHeading/CommonPageHeading';
import * as jnb from 'react-bootstrap';
import Sweetalert, { saveAlert } from '../../../CommonUtils/CommonPopupAndAlerts/SweetAlerts';
import { config } from '../../../CommonUtils/CommonUrl/CommonUrls';
import { CommonAxiosPost } from '../../../CommonUtils/CommonAxios/CommonAxios';
import { useSelector } from 'react-redux';
import Header from '../../../Header/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import * as Yup from "yup";
import { ERROR_MSG } from '../../../CommonUtils/Validations/RegularExpAndVar';
export default function InwardCheckerDateWiseReport() {
    const loginreducer = useSelector((state) => state?.reducers?.loginreducer?.loginDetails?.loginData);
    const [showList, setList] = useState([]);
    const location = useLocation();
    const data = location?.state?.data
    const InWardValidation =
        Yup.object().shape({
            checkerRemarks: Yup.string().required(ERROR_MSG),
        })
    const Formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            entry_by: loginreducer?.username,
            "in_ward_cheque_in_date": data?.in_ward_cheque_in_date,
            "incharge_cfms_id": data?.incharge_cfms_id,
            "checker_cfms_id": loginreducer?.username,
            "is_confirm": false,
            checkerRemarks: ""
        },
        onSubmit: (values) => {
            // console.log("values", JSON.stringify(values));
            let msg = "Do you want to send back to Maker?"
            Swal.fire({
                title: "Are you sure ?",
                text: msg,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
                cancelButtonText: "No"
            }).then((save) => {
                if (save.isConfirmed) {
                    FinalSubmit(values)
                    
                }
            })
        },
        validationSchema: InWardValidation
    })
    const [isCheckerConfirm, setCheckerConfirm] = useState(false)
    const GetChequeInReport = () => {
       // console.log("Performing GetChequeInReport...");
        let url = config.url.BOC_URL + "inward-datewise";
        let values = {
            "in_ward_cheque_in_date": data?.in_ward_cheque_in_date,
            "incharge_cfms_id": data?.incharge_cfms_id
        }
        return CommonAxiosPost(url, values).then((response) => {
            if (response.data.status === true) {
                setList(response.data.date_wise_report);
                setCheckerConfirm(response.data?.date_wise_report[0]?.is_checker_confirmed)
            }
            else {
                setList([])
            }
        })
    }
    let navigate = useNavigate()
    function SaveOptions(value) {
        let values = {
            "in_ward_cheque_in_date": data?.in_ward_cheque_in_date,
            "incharge_cfms_id": data?.incharge_cfms_id,
            "checker_cfms_id": loginreducer?.username,
            "is_confirm": value
        }
        FinalSubmit(values)
    }
    function FinalSubmit(values) {
        let url = config.url.BOC_URL + "inward-checker-confirmation";
        CommonAxiosPost(url, values).then((res) => {
            if (res?.data?.scode === '01') {
                if (values.is_confirm === true) {
                    Sweetalert("SuccessFully Saved Your Response", 'success')
                    GetChequeInReport()
                    navigate(-1)
                }
                else {
                    Sweetalert("SuccessFully send back to Maker", 'success')
                }


            }
            else if (res.data.scode === '02') {
                Sweetalert(res.data.sdesc, 'warning')
            }

        })
    }
    useEffect(() => {
        GetChequeInReport()
    }, [])
    return (
        <React.Fragment>
            <Header />
            <div className="main_section"> </div>
            <CommonPageHeading heading="Inward Checker Date Wise Report" />
            <jnb.Container className="outer-page-content-container" >
                <FormikProvider value={Formik}>
                    <jnb.Form onChange={Formik.handleChange} onSubmit={Formik.handleSubmit} className="form_adjust">
                        <div className="table-responsive">
                            <table className="table table-condensed table-bordered table-striped table-responsive mb-0 mt-1"
                                style={{ border: '2px solid lightblue', width: '100%', borderCollapse: 'collapse', }}>
                                <thead >
                                    <tr>
                                        <th>S.NO</th>
                                        <th>Organisation Name</th>
                                        <th>LR No. & Date</th>
                                        <th >Dept </th>
                                        <th >Work Executed at</th>
                                        <th>Date of Recieving</th>
                                        <th>By Dept / Extl</th>
                                        <th>Name of Bank</th>
                                        <th>Branch</th>
                                        <th>DD /Cheque</th>
                                        <th>cheque No. /DD No.</th>
                                        <th>Date</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {showList.map((item, index) => (
                                        <tr key={index}>                        
                                            <td>{index + 1}</td>
                                            <td>{item.organisation_name}</td>
                                            <td>{item.lr_no_and_date}</td>
                                            <td>{item.dept}</td>
                                            <td>{item.work_executed_at_district_name}</td>
                                            <td>{item.date_of_recieving}</td>
                                            <td>{item.by_dept}</td>
                                            <td>{item.name_of_bank}</td>
                                            <td>{item.branch}</td>
                                            <td>{item.dd_cheque}</td>
                                            <td>{item.cheque_no_or_ddno}</td>
                                            <td>{item.date}</td>
                                            <td>{item.amount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={11}></td>
                                        <td>Total</td>
                                        <td>
                                            {showList?.reduce(
                                                (a, v) => (a = a + v.amount),
                                                0
                                            )}
                                        </td>
                                    </tr>
                                    {isCheckerConfirm === true ?
                                        <React.Fragment></React.Fragment>
                                        : <React.Fragment>
                                            {showList?.length > 0 ?
                                                <tr>
                                                    <td colSpan={2}>
                                                        <jnb.InputGroup className="">
                                                            <label>Remarks</label>
                                                            <Field type="text" className="form-control w-100 mt-1" name="checkerRemarks" />
                                                            <ErrorMessage name="checkerRemarks" component="div" className="text-error" />
                                                        </jnb.InputGroup></td>
                                                    <td><button type="submit" className="btn btn-danger btn-md mt-3"> Back</button></td>
                                                    <td colSpan={10} style={{ textAlign: "right" }}>
                                                        <button type="button" onClick={() => { SaveOptions(true) }} className="btn btn-success btn-md"> Confirm</button></td>
                                               </tr> : <React.Fragment></React.Fragment>}
                                        </React.Fragment>}
                                </tfoot>
                            </table>
                        </div>
                    </jnb.Form>
                </FormikProvider>
            </jnb.Container>




        </React.Fragment>
    )
}
